import React from 'react';

function Section({ title, children }) {
  return (
    <section style={{ display: 'grid', gap: 8 }}>
      <h2 style={{ margin: '0 0 4px', fontSize: 20 }}>{title}</h2>
      <div style={{ color: 'var(--muted)', lineHeight: 1.6, fontSize: 15 }}>
        {children}
      </div>
    </section>
  );
}

export default function DeleteAccount() {
  return (
    <div className="container" style={{ paddingTop: 32, paddingBottom: 48 }}>
      <div className="card" style={{ display: 'grid', gap: 24 }}>
        <div style={{ display: 'grid', gap: 8 }}>
          <p style={{ fontWeight: 700, color: 'var(--muted)', margin: 0 }}>Account Deletion</p>
          <h1 style={{ margin: 0, fontSize: 28, letterSpacing: '-0.01em' }}>Delete Your Sellantra Account</h1>
          <p style={{ margin: 0, color: 'var(--muted)' }}>Last updated: January 2026</p>
          <p style={{ margin: 0, color: 'var(--muted)' }}>
            Sellantra allows users to permanently delete their shop/organization and all associated data directly from within the app.
          </p>
        </div>

        <Section title="How to delete your account">
          <ol style={{ margin: 0, paddingLeft: 18, display: 'grid', gap: 8 }}>
            <li>Log in to the Sellantra app.</li>
            <li>Go to Settings.</li>
            <li>Select <strong>Delete Shop / Organization</strong>.</li>
            <li>Type <strong>Your Shop / Organisation Name</strong> to confirm deletion.</li>
          </ol>
          <p style={{ margin: '8px 0 0', color: 'var(--danger)', fontWeight: 600 }}>
            ⚠️ This action is permanent and cannot be undone.
          </p>
        </Section>

        <Section title="What data is deleted">
          <ul style={{ margin: 0, paddingLeft: 18, display: 'grid', gap: 8 }}>
            <li>User account information.</li>
            <li>Shop / organization details.</li>
            <li>Products and inventory.</li>
            <li>Customers.</li>
            <li>Invoices, sales, and returns.</li>
            <li>All associated business data.</li>
          </ul>
        </Section>

        <Section title="Data retention">
          <ul style={{ margin: 0, paddingLeft: 18, display: 'grid', gap: 8 }}>
            <li>Deleted data is permanently removed from our systems.</li>
            <li>Some minimal logs may be retained for up to 30 days for security or legal purposes.</li>
          </ul>
        </Section>

        <Section title="Need help?">
          <p style={{ margin: 0 }}>
            If you are unable to access the app or need assistance with deletion, contact:
          </p>
          <p style={{ margin: '4px 0 0', fontWeight: 600 }}>
            📧 <a href="mailto:sujitsahu007@gmail.com">sujitsahu007@gmail.com</a>
          </p>
        </Section>
      </div>
    </div>
  );
}